var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReturnsScanIcon = function SvgReturnsScanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7453 8C16.4804 6.18652 14.3788 5 12 5C8.82899 5 6.15044 7.10851 5.28989 10H3.22303C4.13249 5.99202 7.71684 3 12 3C14.8272 3 17.3499 4.3036 18.9999 6.34251V3H20.9999V10H20.777H18.7101H13.9999V8H17.7453ZM20.9998 12.067L21 12L20.9998 11.933V12.067ZM6.25469 16C7.51964 17.8135 9.62125 19 12 19C15.171 19 17.8496 16.8915 18.7101 14H20.777C19.8675 18.008 16.2832 21 12 21C9.17281 21 6.65009 19.6964 5.00013 17.6575L5.00013 21H3.00013L3.00013 14H3.22302L5.28988 14H10.0001V16H6.25469ZM3.00024 11.933L3 12L3.00024 12.067L3.00024 11.933Z",
    fill: "auto"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReturnsScanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/returns-scan-icon.9697a21d.svg";
export { ForwardRef as ReactComponent };